// GoogleDisplay For Nestoria
// Copy from: whitelabel-web/src/trovit/ts/serp/components/googleDisplay.ts
// Adapt to Nestoria

import {CONSENT_COOKIE_NAME} from "../gdpr/DisclaimerCookie";

declare global {
    interface Window {
        googletag: any;
    }
}

export interface GoogleTag {
    cmd: {
        push: (callback: () => void) => void;
    },
    pubads: () => {
        setPrivacySettings: (settings: { nonPersonalizedAds: boolean }) => void;
        enableSingleRequest: () => void;
        collapseEmptyDivs: (collapse: boolean) => void;
        refresh: (slots?: any[]) => void;
        getSlots: () => any[];
    },
    defineOutOfPageSlot: (anchor:any, format: any) => {
        addService: (pudAdd: any) => void;
        setConfig: (slotConfig: any) => void;
    },
    display: (param: any) => void,
    enums: {
        OutOfPageFormat: {
            BOTTOM_ANCHOR: 'BOTTOM_ANCHOR'
        }
    },
}

const DISPLAY_CONTAINER_CLASS = ".display-container";

const nestoriaPersonalizedGoogleAds = (): boolean => {
    return document.cookie.includes(CONSENT_COOKIE_NAME + "=true");
}

const buildCallback = (
    googletag: any,
    unitPath: string,
    sizes: any[],
    identifier: string,
    variables: any,
    callDisplayFunction: boolean,
) => {
    return () => {
        const slot = googletag.defineSlot(unitPath, sizes, identifier)
            .addService(googletag.pubads());
        Object.entries(variables).forEach(([key, value]) => {
            slot.setTargeting(key, value);
        });

        if (nestoriaPersonalizedGoogleAds()) {
            googletag.pubads().setTargeting("personalized", "true");
        } else {
            googletag.pubads().setTargeting("personalized", "false");
        }

        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs(true);
        googletag.pubads().enableLazyLoad({
            fetchMarginPercent: 100,
            renderMarginPercent: 50,
            mobileScaling: 3.0
        });
        googletag.enableServices();
        if (callDisplayFunction) {
            googletag.display(identifier);
        }
    }
}

class GoogleDisplay {

    private readonly googleTag: GoogleTag;
    private readonly dom: any;

    constructor(googleTag: GoogleTag, dom: any) {
        this.googleTag = googleTag;
        this.dom = dom;
    }


    init(pageType: string) {
        window.addEventListener('load', () => {
            if (pageType === FREE_CLICK_DETAIL_PAGE) {
                this.initDisplaySlots(false);
                this.initAnchorsAndDisplayDFP();
            } else if (pageType === SERP_PAGE) {
                /* SERP Page. No Anchor */
                this.initDisplaySlots(true);
            } else if (pageType === NOT_FOUND_PAGE) {
                /* Not Found Page. No Anchor */
                this.initDisplaySlots(true);
            }
        });
    }

    initDisplaySlots(callDisplayFunction: boolean) {
        this.dom.selectAll(DISPLAY_CONTAINER_CLASS)?.forEach((containerEl: Element) => {
            const identifier = containerEl.getAttribute("data-identifier")!!;
            const unitPath = containerEl.getAttribute("data-ad-unit-path")!!;
            const sizes = JSON.parse(containerEl.getAttribute("data-sizes")!!);
            const variables = JSON.parse(containerEl.getAttribute("data-target")!!);
            this.googleTag.cmd.push(buildCallback(this.googleTag, unitPath, sizes, identifier, variables, callDisplayFunction));
        });
    }

    initAnchorsAndDisplayDFP() {
        this.dom.selectAll('.display-container-desktop-anchor')?.forEach((containerEl: Element) => {
            this.displayAnchorSlot('/1012781/NEST_ANCHOR_DESKTOP')
        });
        this.dom.selectAll('.display-container-mobile-anchor')?.forEach((containerEl: Element) => {
            this.displayAnchorSlot('/1012781/NEST_ANCHOR_MOBILE')
        });
    }

    private displayAnchorSlot(anchorName: string) {
        this.googleTag.cmd.push( () => {
            const anchorSlot = this.googleTag.defineOutOfPageSlot(anchorName, this.googleTag.enums.OutOfPageFormat.BOTTOM_ANCHOR);
            if (anchorSlot) {
                anchorSlot.addService(this.googleTag.pubads());
                this.googleTag.display(anchorSlot);
            }
        } );
    }
}

export default GoogleDisplay
export const FREE_CLICK_DETAIL_PAGE: string = "FreeClickDetailPage";
export const SERP_PAGE: string = "SerpPage";
export const NOT_FOUND_PAGE: string = "NotFoundPage";
